{
  "commerce": {
    "aiChatView": {
      "errorPausedDetail": "L’IA est incluse dans l’abonnement : ouvrez Paramètres → Facturation pour vous abonner."
    },
    "billingPage": {
      "title": "Facturation"
    },
    "paywallGate": {
      "errorOpenBilling": "Impossible d’ouvrir la page de facturation. Réessayez.",
      "lapsedDescription": "Réabonnez-vous pour continuer à gérer votre établissement : 30 € par logement et par mois, IA incluse.",
      "pastDue": "Le paiement a échoué. Mettez à jour votre moyen de paiement pour garder votre accès à Vidimo.",
      "startTrial": "Commencer l’essai gratuit de {days} jours",
      "subscribe": "S’abonner",
      "subscribeDescription": "Vous avez déjà utilisé votre essai gratuit. Abonnez-vous pour continuer à gérer votre établissement : 30 € par logement et par mois, IA incluse.",
      "subscribeTitle": "S’abonner à Vidimo",
      "trialAddPaymentMethod": "Ajoutez un moyen de paiement pour garder votre accès à Vidimo.",
      "trialDescription": "Essayez Vidimo gratuitement pendant {days} jours, sans carte bancaire. Ensuite, 30 € par logement et par mois, IA incluse.",
      "trialTitle": "Commencez votre essai gratuit"
    },
    "propertySettingsView": {
      "billingDescription": "Abonnement, utilisation de l’IA et moyen de paiement",
      "billingTitle": "Facturation"
    },
    "subscriptionGate": {
      "aiIncluded": "Les fonctions d’IA sont incluses dans votre offre.",
      "aiTitle": "IA",
      "errorGeneric": "Une erreur est survenue",
      "errorLoad": "Impossible de charger vos informations de facturation",
      "manageSubscription": "Gérer l’abonnement",
      "status": {
        "active": "Actif",
        "past_due": "Paiement en retard",
        "trialing": "Essai gratuit"
      },
      "subscribe": "S’abonner",
      "subscribePrice": "30 € par logement et par mois, facturés selon le nombre de logements de cet établissement. Fonctions d’IA incluses.",
      "subscribeTitle": "S’abonner",
      "subscribedPrice": "30 € par logement et par mois. Votre facture s’ajuste automatiquement quand vous ajoutez ou retirez un logement.",
      "subscriptionTitle": "Abonnement"
    }
  }
}
